import { useEffect } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'

import useUser from 'hooks/useUser'

import useDashboard from '../../hooks/useDashboard'

export default function DashboardManager() {
    const { isLoggedIn, isAutoDealership, user, isMultiAssetDealership } =
        useUser()

    const location = useLocation()
    const { pathname } = location
    const navigate = useNavigate()
    const { hasDashboard, status } = useDashboard()

    const isHomePage =
        window.location.hash === '#!/' ||
        window.location.hash === '#/' ||
        // root path
        (window.location.hash === '' && window.location.pathname === '/')

    // Check if there's a redirect from login
    const hasLoginRedirect = location.state?.redirectTo

    // Pathname is not included in the dependency list to avoid redirecting
    // a non-auto user if they intend to go to the homepage
    useEffect(
        () => {
            if (isMultiAssetDealership) return

            // Don't redirect to dashboard if there's a login redirect pending
            if (hasLoginRedirect) return

            if (isHomePage && isLoggedIn && !pathname.includes('invitation')) {
                if (isAutoDealership || hasDashboard) {
                    navigate('dashboard')
                }
            }
        },
        // eslint-disable-next-line react-hooks/exhaustive-deps
        [
            isAutoDealership,
            isLoggedIn,
            status,
            hasDashboard,
            user,
            hasLoginRedirect,
        ],
    )

    return null
}
